import { cloneDeep, sortBy } from 'lodash';

import { ApiServiceServerless } from '../../../xhr_libs';


import {
  getPlugCredentials,
  PLUG_CREDENTIAL_COLUMNS,
  getPlugAccountColumns,
  getPlugAccounts,
  updatePlugUsername,
  updatePlugPassword,
} from './plug';



export const updateCredentialState = (setter, id, property, newValue) => {
  setter((prev) =>
    prev.map((cred) => {
      if (id !== cred.credentialId) return cred;
      let updatedCred = cloneDeep(cred);
      updatedCred[property] = newValue;
      return updatedCred;
    })
  );
};

export const handleGetAllCredentials = (
  setAllCredentials,
  setCredentialIds,
  organizationId,
  posr,
  hiddenCredentials,
  setIsLoading,
  setAccountsOveride,
  showToast
) => {
  setIsLoading(true);
  if (organizationId) {
    const shared_orgs = getSharedOrgs(posr);
    let orgs = [];
    orgs.push(organizationId);
    shared_orgs.forEach((org) => orgs.push(org));

    let localHiddenCredentialIds = [];
    let hidden_crednentials =
      hiddenCredentials || [];
    localHiddenCredentialIds = hidden_crednentials.map(
      (cred) => cred.credential
    );
    getPlugCredentials(
      setAllCredentials,
      setCredentialIds,
      organizationId,
      orgs,
      localHiddenCredentialIds,
      setIsLoading,
      setAccountsOveride,
      showToast
    );
  }
};

const getSharedOrgs = (provider_shares) => {
  if (!provider_shares) {
    return [];
  }
  return provider_shares
    .map((share) => {
      return share.owner_id;
    });
};

export const getCredentialColumns = (setCredentialColumns) => {
  setCredentialColumns(PLUG_CREDENTIAL_COLUMNS);
};

export const getAccountColumns = (
  setAccountColumns,
  handleOpenLinkModal,
  updateAccess
) => {
  setAccountColumns(getPlugAccountColumns(handleOpenLinkModal, updateAccess));

};

export const handleRefreshAccountsData = (
  setPseudoCredentials,
  setProviderAccounts,
  setLocalUtilityAccounts,
  setLocalBuildings,
  organizationId,
  credentialIds,
  setIsLoading,
  showToast
) => {
  setIsLoading(true);
  setProviderAccounts([]);

  if (organizationId) {
    getPlugAccounts(
      setPseudoCredentials,
      setProviderAccounts,
      organizationId,
      credentialIds,
      showToast,
      setIsLoading
    );
    handleRefreshLocalData(
      setLocalUtilityAccounts,
      setLocalBuildings,
      organizationId
    );
    setIsLoading(false);
  }
};

export const handleRefreshLocalData = (
  setLocalUtilityAccounts,
  setLocalBuildings,
  organizationId,
  showToast
) => {
  const getLocalUtilityAccounts = () => {
    ApiServiceServerless.get(
      `/utility_accounts/organization/${organizationId}`,
      { authorization_id: organizationId }
    )
      .then(({ data }) => {
        setLocalUtilityAccounts(sortBy(data, 'account_number'));
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      });
  };

  const getLocalBuildings = () => {
    ApiServiceServerless.get(`/buildings/organization/${organizationId}`, {
      authorization_id: organizationId,
    })
      .then(({ data }) => {
        setLocalBuildings(sortBy(data, 'name'));
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      });
  };
  getLocalUtilityAccounts();
  getLocalBuildings();
};


export const handleUpdateUsername = (
  params,
  credential,
  setAllCredentials,
  showToast
) => {

  updatePlugUsername(
    params,
    credential,
    updateCredentialState,
    setAllCredentials,
    showToast
  );

};

export const handleUpdatePassword = (params, showToast) => {
  updatePlugPassword(params, showToast);
};






